import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { ImageModule } from '@epicuro-next/ataraxia/image';
import { VideoPlayerModule } from '@epicuro-next/ataraxia/video-player';

import { Media360Component } from './media-360/media-360.component';
import { MediaComponent } from './media/media.component';

/**
 * Module declarations that are meant to be used outside of this module
 */
export const PUBLIC_DECLARATIONS = [MediaComponent, Media360Component];

@NgModule({
  declarations: PUBLIC_DECLARATIONS,
  imports: [CommonModule, ImageModule, VideoPlayerModule, IconsModule],
  exports: PUBLIC_DECLARATIONS,
})
export class MediaModule {}
